import { IconProps } from '@mui/material';
import React from 'react';

import AtomIcon from '../../atoms/AtomIcon/AtomIcon';
import AtomImage from '../../atoms/AtomImg/AtomImage';

export interface IIconComponentProps {
  id?: string;
  alt?: string;
  src: string;
  imgProps?: React.ImgHTMLAttributes<HTMLImageElement>;
}

const IconComponent: React.FC<IconProps & IIconComponentProps> = ({
  id = 'icon_component',
  alt = 'icon component',
  src,
  imgProps,
  ...props
}) => (
  <AtomIcon {...props}>
    <AtomImage data-testid={id} alt={alt} src={src} {...imgProps} />
  </AtomIcon>
);

export default IconComponent;
